<template>
    <div class="container" :class="language">
        <img src="../../../static/images/index/t_bg.png" class="bgImg" alt="" />
        <img src="../../../static/images/index/logo_w.png" class="logoImg" alt="" />
        <div class="ticket-box">
            <img src="../../../static/images/index/canvas_top.png" class="jag1" />
            <img src="../../../static/images/index/canvas_btm.png" class="jag2" />
            <div class="tb-top">
                <span class="iconfont icon-success"></span>
                <div class="text1">{{ content.success }}</div>
                <div class="dividing" v-if="language == 'zh'"><span>登</span><span>记</span><span>信</span><span>息</span></div>
                <div class="dividing" v-else>Registration information</div>
                <div class="name">{{ info.Name }}</div>
                <div class="cname">{{ info.CompanyName }}</div>
            </div>
            <div class="tb-btm">
                <div v-html="content.exh"></div>
            </div>
        </div>
        <div class="notice-box">
            <div>{{ content.notice }}</div>
            <div v-html="content.details"></div>
        </div>
    </div>
</template>
<script>
import { visitInfo } from "@/api/exhibition";
export default {
    name: "ticket",
    components: {},
    data() {
        return {
            language: 'zh',
            // 语言内容定义
            messages: {
                zh: {
                    success: "门票登记成功",
                    exh: "展会时间：2026年6月9至12日<br/>展会地点：中国进出口商品交易琶洲展馆<br/>展会入场请出示：纸质胸卡及本人有效证件入场参观",
                    notice: '入场须知',
                    details: '1. 根据政府相关要求，参观展会须实名预约登记，观展当天凭预约码换取纸质胸卡！凡进馆人员均须查验【纸质胸卡】+【本人有效证件】入场参观。<br/>2. 进入展馆前，请在现场扫描二维码用于激活门票预约码，以便换取纸质胸卡票进入展馆。<br/>3. 主办单位将会核实阁下的专业观众身份，并保留拒绝向非专业观众或提供虚假资料人士发出专业观众证的权利。<br/>4. 持卡人必须遵从并接受主办单位安排的保安检查程序。<br/>5. 本届展会采用实名登记方式，一人一证，不得转让。<br/>6. 此展览只供 18 岁或以上的业内人士参观。',
                },
                en: {
                    success: "Ticket registration successful",
                    exh: "Time: 9-12 June 2026<br/>Add: No. 382, Yuejiang Zhong Road, Guangzhou China<br/>Entry Instructions: Enter the exhibition area with the physical name badge and your valid identification document.",
                    notice: 'Entry Instructions:',
                    details: '1. According to the relevant requirements of the government, visitors to the exhibition must make a real-name reservation and registration. On the day of the exhibition, the reservation code will be used to obtain a paper badge! All visitors entering the venue must present both the [paper badge] and [their own valid identification] to enter and view the exhibition.<br/>2. Before entering the exhibition hall, please exchange a paper badge ticket at the site to gain access to the exhibition.<br/>3. The organizing committee will verify your identity as a professional visitor and reserves the right to refuse to issue professional visitor cards to non-professional visitors or those who provide false information.<br/>4. The cardholder must comply with and accept the security inspection procedures arranged by the organizing party.<br/>5. This exhibition adopts a real-name registration system. Each person is assigned a unique identification card and the card cannot be transferred.<br/>6. This exhibition is only open to professionals aged 18 or above.'
                }
            },
            content: "",
            info: "",
        };
    },
    computed: {},
    methods: {},
    mounted() {
        var that = this;
        const lang = localStorage.getItem('lang') || that.$route.query.lang || 'zh';
        that.language = lang;
        that.content = that.messages[lang];
        // if(localStorage.getItem('mobile')){
        visitInfo({
            "Mobile": localStorage.getItem('mobile')
        }).then((res) => {
            that.info = res.Data;
        })
        // }
    },
};
</script>
<style scoped>
.container {
    background-color: #0E1937;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 20px 25px 50px 25px;
}

.bgImg {
    width: 100%;
    height: auto;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
}

.logoImg {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 20px;
}

.ticket-box {
    position: relative;
    z-index: 3;
    padding: 10px 0;
    font-size: 12px;
}

.jag1 {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 336px;
}

.jag2 {
    position: absolute;
    z-index: -1;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 55px;
}

.tb-top {
    height: 277px;
    padding-top: 22px;
    box-sizing: border-box;
    background: #ECEDF6;
    text-align: center;
    color: #000000;
    font-size: 13px;
}

.tb-top .icon-success {
    font-size: 63px;
    line-height: 63px;
    color: #4CB52C;
}

.tb-top .text1 {
    margin-top: 15px;
    font-size: 28px;
    line-height: 30px;
    font-weight: bold;
}

.dividing {
    margin: 30px auto 20px;
    width: 96px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dividing::before,
.dividing::after {
    content: "";
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    width: 81px;
    height: 1px;
    background: #C6C8D2;
}

.dividing::before {
    left: 100%;
}

.dividing::after {
    right: 100%;
}

.dividing span {
    width: 19px;
    height: 19px;
    background: #C6C8D2;
    border-radius: 50%;
    text-align: center;
    line-height: 19px;
    font-size: 13px;
    color: #ffffff;
}

.tb-top .name {
    font-size: 20px;
    line-height: 23px;
}

.tb-top .cname {
    font-size: 13px;
    margin-top: 10px;
}

.tb-btm {
    height: 80px;
    box-sizing: border-box;
    background-color: #CBD9EE;
    color: #41456B;
    font-size: 12px;
    line-height: 20px;
    padding: 12px 15px 0 15px;
}

.invite-btn {
    margin-top: 20px;
    height: 40px;
    text-align: center;
    line-height: 80px;
    background: #D62F2F;
    border-radius: 20px;
    font-size: 18px;
    color: #FFFFFF;
    font-weight: bold;
}

.home-btn {
    margin: 15px auto 0;
    width: 110px;
    font-size: 13px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notice-box {
    margin-top: 30px;
}

.notice-box div {
    color: #ffffff;
    font-size: 12px;
    line-height: 23px;
}

.notice-box div:first-child {
    position: relative;
    font-weight: bold;
    font-size: 18px;
    padding-left: 9px;
    margin-bottom: 10px;
}

.notice-box div:first-child::before {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    content: "";
    width: 5px;
    height: 18px;
    background: #CE1D64;
}


.en .tb-top .text1 {
    font-size: 20px;
}

.en .dividing {
    width: 155px;
    font-size: 13px;
    color: #999;
}

.en .dividing::before,
.en .dividing::after {
    width: 60px;
}

.en .tb-btm {
    height: auto;
    padding-bottom: 5px;
}
</style>